import { gettingStarted } from './privateCloudBusinessEditionExistEnvConfig';
export const pagesConfig = [...gettingStarted()];
